export const LOCALES = [
  'en',
  'hr',
  'de',
  'it',
  'fr',
  'es',
  'pl',
  'cs',
  'sk',
  'hu',
  'sl',
  'sr',
] as const

export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'en'

export const LOCALE_META: Record<
  Locale,
  {
    label: string
    endonym: string
    htmlLang: string
    hrefLang: string
    ogLocale: string
    dir: 'ltr'
  }
> = {
  en: {
    label: 'EN',
    endonym: 'English',
    htmlLang: 'en',
    hrefLang: 'en',
    ogLocale: 'en_GB',
    dir: 'ltr',
  },
  hr: {
    label: 'HR',
    endonym: 'Hrvatski',
    htmlLang: 'hr',
    hrefLang: 'hr',
    ogLocale: 'hr_HR',
    dir: 'ltr',
  },
  de: {
    label: 'DE',
    endonym: 'Deutsch',
    htmlLang: 'de',
    hrefLang: 'de',
    ogLocale: 'de_DE',
    dir: 'ltr',
  },
  it: {
    label: 'IT',
    endonym: 'Italiano',
    htmlLang: 'it',
    hrefLang: 'it',
    ogLocale: 'it_IT',
    dir: 'ltr',
  },
  fr: {
    label: 'FR',
    endonym: 'Français',
    htmlLang: 'fr',
    hrefLang: 'fr',
    ogLocale: 'fr_FR',
    dir: 'ltr',
  },
  es: {
    label: 'ES',
    endonym: 'Español',
    htmlLang: 'es',
    hrefLang: 'es',
    ogLocale: 'es_ES',
    dir: 'ltr',
  },
  pl: {
    label: 'PL',
    endonym: 'Polski',
    htmlLang: 'pl',
    hrefLang: 'pl',
    ogLocale: 'pl_PL',
    dir: 'ltr',
  },
  cs: {
    label: 'CS',
    endonym: 'Čeština',
    htmlLang: 'cs',
    hrefLang: 'cs',
    ogLocale: 'cs_CZ',
    dir: 'ltr',
  },
  sk: {
    label: 'SK',
    endonym: 'Slovenčina',
    htmlLang: 'sk',
    hrefLang: 'sk',
    ogLocale: 'sk_SK',
    dir: 'ltr',
  },
  hu: {
    label: 'HU',
    endonym: 'Magyar',
    htmlLang: 'hu',
    hrefLang: 'hu',
    ogLocale: 'hu_HU',
    dir: 'ltr',
  },
  sl: {
    label: 'SL',
    endonym: 'Slovenščina',
    htmlLang: 'sl',
    hrefLang: 'sl',
    ogLocale: 'sl_SI',
    dir: 'ltr',
  },
  sr: {
    label: 'SR',
    endonym: 'Srpski',
    htmlLang: 'sr-Latn',
    hrefLang: 'sr-Latn',
    ogLocale: 'sr_RS',
    dir: 'ltr',
  },
}

export const isLocale = (value: string): value is Locale =>
  (LOCALES as readonly string[]).includes(value)
